import {Col, Container} from "react-bootstrap";
import "../css/error404.css"
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHomeLg } from "@fortawesome/free-solid-svg-icons";

function Error404() {
  const location = useLocation();
  let invalidPage = null
  
  
  return (
    <>
      <section>
        <Container className="my-4 d-flex justify-content-center align-items-center height ">
            
            <div id="notfound">
            <div className="notfound">
            <div className="notfound-404">
            <h1 className="align-baseline">Oops!</h1>
            </div>
            <h2>404 page not found</h2>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>  
                <Link to="/" className="me-1 text-decoration-none">
                  <button className="btn btn-success text-uppercase">
                    <FontAwesomeIcon icon={faHomeLg} className="me-1" /> Go to Homepage
                  </button>
                </Link>            
            </div>
            </div>
                  
        </Container>
      </section>
    </>
  );
}
export default Error404;
